import React from "react";
import { motion } from "framer-motion";
import { Instagram, Youtube, Twitter, ArrowUpRight } from "lucide-react";
import { SectionLabel, Reveal } from "./ui";
import { useSettings } from "../../context/SettingsContext";
import { resolveImg } from "../../lib/api";

export const About = () => {
  const { settings } = useSettings();
  const portrait = resolveImg(settings?.about_photo || "/about-portrait.jpg");

  return (
    <section id="about" className="relative py-24 md:py-32 px-6 md:px-10">
      <div className="mx-auto max-w-7xl">
        <SectionLabel className="mb-14">About</SectionLabel>

        <div className="grid md:grid-cols-[0.8fr_1.2fr] gap-10 md:gap-16 items-center">
          <Reveal>
            <div className="relative overflow-hidden border" style={{ borderColor: "var(--border-color)", borderRadius: "18px", aspectRatio: "4/5" }}>
              <img src={portrait} alt="Bishal Banerjee" loading="lazy" className="h-full w-full object-cover" />
            </div>
          </Reveal>

          <div>
            <Reveal>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight">
                Hey, I'm <span style={{ color: "var(--accent-color)" }}>Bishal.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-lg text-lg md:text-xl leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                I'm a video editor and creative building a studio around content that deserves attention.
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-10 flex flex-wrap gap-4">
                <a
                  href={settings?.instagram_url || "#"}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="about-instagram"
                  className="group inline-flex items-center gap-3 border px-5 py-3 text-sm transition-colors duration-300 hover:border-[var(--accent-color)]"
                  style={{ borderColor: "var(--border-color)", borderRadius: "var(--btn-radius)" }}
                >
                  <Instagram size={18} /> Instagram
                  <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
                <a
                  href={settings?.twitter_url || "#"}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="about-twitter"
                  className="group inline-flex items-center gap-3 border px-5 py-3 text-sm transition-colors duration-300 hover:border-[var(--accent-color)]"
                  style={{ borderColor: "var(--border-color)", borderRadius: "var(--btn-radius)" }}
                >
                  <Twitter size={18} /> X / Twitter
                  <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
                {settings?.youtube_url && (
                  <a
                    href={settings.youtube_url}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="about-youtube"
                    className="group inline-flex items-center gap-3 border px-5 py-3 text-sm transition-colors duration-300 hover:border-[var(--accent-color)]"
                    style={{ borderColor: "var(--border-color)", borderRadius: "var(--btn-radius)" }}
                  >
                    <Youtube size={18} /> YouTube
                    <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                )}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
